import { ShareStatus } from "@authory-packages/core";
import {
    getServerSidePropsWithCollection,
    V3CollectionPublicPageLayoutContainer
} from "../../../../pagelayouts/collection-details/CollectionDetailsPublicPageLayoutContainer";
import { ProfileAccessGate } from "../../../../pages-components/ProfileAccessGate/ProfileAccessGate";

export default function CollectionProfilePublicPage({ profileShareStatus }: { profileShareStatus: ShareStatus }) {
    return (
        <ProfileAccessGate profileShareStatus={profileShareStatus}>
            <V3CollectionPublicPageLayoutContainer
                isStandaloneCollectionView={false}
                profileShareStatus={profileShareStatus}
                useProfileSmartShareEndpoint={false}
                useCollectionSmartShareEndpoint={false}
            />
        </ProfileAccessGate>
    );
}

export const getServerSideProps = getServerSidePropsWithCollection(false, true);
